import { useVisibilityStore, useVODStore } from '@/shared/store'
import {
    selectItemDetails,
    selectRemoveItemDetails,
    selectSetIsVodContentPlaying,
    selectSetSelectedVOD,
    selectSetVodRowItemType,
} from '@/shared/store/storeSelectors/vodSelectors'
import { useLocation, useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { useGetVodDetailsContext } from '@/features/VOD/context'
import {
    homePagePath,
    isPurchasedBuy,
    isPurchasedPlay,
    vodPagePath,
} from '@/shared/constants'
import { useVODService } from '@/app/context/DIContext/DIServices'
import { seriesPagePath } from '@/shared/constants/seriesConstants'
import { useVodContentContext } from '@/features/VOD/context/UseGetVodContextContext/useVodContentContext'

export const useVodItemDetailsPage = () => {
    const { triggerScrollHandler } = useVodContentContext()
    const { setHomeContentVisible } = useVisibilityStore()
    const itemDetails = useVODStore(selectItemDetails)
    const { searchItemDetails } = useVODStore()
    const { setVodPages } = useVODStore()
    const setVodRowItemType = useVODStore(selectSetVodRowItemType)
    const removeItemDetail = useVODStore(selectRemoveItemDetails)
    const setIsVodContentPlaying = useVODStore(selectSetIsVodContentPlaying)
    const setSelectedVOD = useVODStore(selectSetSelectedVOD)
    const {
        isVodContentPlaying,
        setIsLinkedFromHome,
        isLinkedFromHome,
        playbackPosition,
        selectedVOD,
        setActualSeason,
        setIsVodDetailsPageRendered,
        isVodDetailsPageRendered,
    } = useVODStore()

    const actualItemDetails = itemDetails?.[itemDetails?.length - 1]
    const [vodHistory, setVodHistory] = useState<string[]>([])
    const { getPlaybacksPosition } = useVODService()

    const navigate = useNavigate()
    const { pathname } = useLocation()
    const path = pathname === seriesPagePath ? seriesPagePath : vodPagePath
    // const mainScreen = document.getElementById('MainScreen')

    const movieFetchData = {
        productId:
            actualItemDetails?.item.productId ||
            `${searchItemDetails?.internalDeepLinkContentId}`,
        assetType:
            actualItemDetails?.item.assetType ||
            searchItemDetails?.internalDeepLinkType ||
            '',
        id:
            actualItemDetails?.item.id ||
            searchItemDetails?.internalDeepLinkContentId.toString() ||
            '',
        serviceName:
            actualItemDetails?.item.serviceName ||
            searchItemDetails?.serviceName ||
            '',
    }

    const { details, getItemDetails, error } = useGetVodDetailsContext()

    const { assetType } = movieFetchData

    const canPlayOrBuyVOD =
        details?.isPurchased === isPurchasedBuy ||
        details?.isPurchased === isPurchasedPlay ||
        Boolean(details?.trailerProductId) ||
        details?.isPurchased === undefined

    const shouldShowError = error || (details && !canPlayOrBuyVOD)

    const goOneStepBack = () => {
        if (isVodContentPlaying) {
            setIsVodContentPlaying(false)
            if (details?.productId && details?.productType) {
                getPlaybacksPosition(
                    details.productId,
                    details.productType,
                    playbackPosition
                )
            }
        } else {
            removeItemDetail()
            setVodRowItemType()
            setVodPages()
            setActualSeason(null)
        }

        setSelectedVOD(null)

        triggerScrollHandler?.({
            isScroll: true,
            amount: 1,
            type: 'decrease',
        })
    }

    const goToVodPage = () => {
        navigate(path)
    }

    const handleBackButtonClick = (): void => {
        if (isLinkedFromHome) {
            setActualSeason(null)
            setIsLinkedFromHome(false)
            setHomeContentVisible()
            navigate(homePagePath)
            setVodPages()
            return
        }
        if (searchItemDetails) {
            goToVodPage()
        } else {
            goOneStepBack()
        }
    }

    useEffect(() => {
        getItemDetails(movieFetchData)
    }, [
        actualItemDetails?.item.productId,
        searchItemDetails?.internalDeepLinkContentId,
    ])

    useEffect(() => {
        setSelectedVOD(null)

        // return () => {
        //     if (mainScreen) {
        //         mainScreen.style.backgroundImage = ''
        //     }
        // }
    }, [details])

    useEffect(() => {
        if (pathname.startsWith(path)) {
            setVodHistory((prevHistory) => [...prevHistory, pathname])
        }
    }, [pathname])

    useEffect(() => {
        const handleBackButton = () => {
            if (vodHistory.length > 1) {
                setVodHistory((prevHistory) => {
                    const updatedHistory = [...prevHistory]
                    updatedHistory.pop()
                    navigate(updatedHistory[updatedHistory.length - 1])
                    return updatedHistory
                })
            } else {
                navigate(-1)
            }
        }

        window.addEventListener('popstate', handleBackButton)

        setIsVodDetailsPageRendered(true)

        return () => {
            window.removeEventListener('popstate', handleBackButton)
        }
    }, [vodHistory, navigate])

    return {
        handleBackButtonClick,
        getItemDetails,
        details,
        movieFetchData,
        selectedVOD,
        shouldShowError,
        assetType,
        isVodDetailsPageRendered,
    }
}
